import { actionAddException } from 'react-redux-app/lib/modules/exception/actions';

import { SITE_SCHEMA } from '../schemas';

import { actionAddCampaigns } from '../../campaign/actions/campaigns';
import { actionAddSites } from './index';

import {
  ACTION_LOAD_SITE__REQUEST,
  ACTION_LOAD_SITE__SUCCESS,
  ACTION_LOAD_SITE__FAIL,
} from '../actionTypes';


export const actionLoadSiteSuccess = () => ({
  type: ACTION_LOAD_SITE__SUCCESS,
});

export const actionLoadSiteFail = error => ({
  type: ACTION_LOAD_SITE__FAIL,
  payload: { error },
});

export const actionLoadSiteRequest = siteId => (
  (dispatch, getState, { apiClientHelper }) => {
    dispatch({
      type: ACTION_LOAD_SITE__REQUEST,
    });

    return apiClientHelper.get(
      `/rest/webmaster/site/${siteId}`,
      {},
      SITE_SCHEMA
    ).then(
      ({ entities }) => {
        dispatch(actionAddCampaigns(entities.campaigns));
        dispatch(actionAddSites(entities.sites));

        dispatch(actionLoadSiteSuccess());
      },
      error => {
        dispatch(actionLoadSiteFail(error));
      }
    ).catch(error => {
      dispatch(actionAddException(error));
    });
  }
);
